import React, { useEffect, useRef, useState } from 'react';
import { AnnounceComponent, ButtonContainer, DroppableArea, ImageContainer, UploadedFilesContainer,
  UploadedFilesImage, UploadedFilesTitle, } from './Component';
import { Divider } from 'primereact/divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '../../core/hooks';
import { selectPerview } from '../../features/previewedPage/previewPageSlice';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
let counter = -1;
const Image = (props: any) => {
  const page =useAppSelector(selectPerview);
  
  
  const [indicator, setindicator] = useState(0); // define the deletion index
  let [files, setfiles] = useState<any[]>([]);
  const [imageURL, setimageURL] = useState('');
  const inputFile: any = useRef(null);
  const ext = ['jpg', 'jpeg', 'png']
  const [stImages, setStImages] = useState<any[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id")
  useEffect(() => {
    if (page.page.id && page.page.media[0]?.type_id === 1) {
      const arrImages = page.page.media.map((img: any) => {
        // return img.url;
        return process.env.REACT_APP_AWS_STORAGE+img.url
      });

      setStImages(arrImages)
      setfiles(arrImages);
      setimageURL(arrImages[0])
      setindicator(0)
    }
    else if(props.page && id){
      const arrImages = props.page.page.page?.media.map((img: any) => {
        return process.env.REACT_APP_AWS_STORAGE+img.url;
      });
      if(arrImages.length){

        setStImages(arrImages)
      }
      setfiles(arrImages);
      setimageURL(arrImages[0])
      setindicator(0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(()=>{
    
    setfiles(stImages);
  },[stImages])
  const maxfileSize:any = localStorage.getItem('one_file_size_max')

  const uploadMultiFiles = (e: any) => {
    if ((e.target.files.length + files.length) <= 5) {
      for (const element of e.target.files) {
        if (element.size > maxfileSize*1024*1024) {
          toast.error(`You have exceeded the limit. Maximum file size should be 5 MB. `, {
            position: toast.POSITION.TOP_CENTER,
          });
        } else if (!ext.includes(element.name.split('.').pop())) {
          toast.error(`Please enter a valid image type between [${ext}]`, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        else {
          setfiles((files) => [...files, URL.createObjectURL(element)]);
          props.setFiles((files: any) => [...files, element]);
          setimageURL(URL.createObjectURL(element));
          counter = counter + 1;
          setindicator(counter)
        }
      }
    }
    else {
      toast.error(`Sorry, you can't upload more than 5 images`, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    e.target.value = '';
  };

  const deleteMainImage = () => {
    let VirtualArray = files;
    VirtualArray.splice(indicator, 1);
    setfiles(VirtualArray);
    counter = counter - 1;
    setimageURL(files[0] ? files[0] : '');
    setindicator(0);
    props.setFiles((files: any) => {
      let arr: any[] = files;
      arr.splice(indicator, 1);
      return arr;
    });
    let ids = props.imgIds;
    ids.splice(indicator, 1);
    props.setimageids(ids);
  };

  return (
    <AnnounceComponent className="p-grid p-mt-2 p-ml-2">
      <ImageContainer className="p-col-12 p-md-9 p-xl-8">
        <UploadedFilesTitle>
          <ButtonContainer className="btn-container">
          Upload Image
            <button
              type="button"
              onClick={() => {
                inputFile.current.click();
              }}
            >
              Upload
              <input
                multiple
                hidden
                type="file"
                ref={inputFile}
                accept="image/*"
                onChange={uploadMultiFiles}
              />
            </button>
        </ButtonContainer>
          
          </UploadedFilesTitle>
        {/* <Divider layout="horizontal"/> */}
        {imageURL ? (
          <div className="main_image">
            <FontAwesomeIcon
              icon={faTrash}
              className="favIcon"
              onClick={deleteMainImage}
            />
            <img src={imageURL} alt="uploaded file" width="100%" height="100%" style={{borderRadius:' 15px'}} />
          </div>
        ) : (
          <DroppableArea></DroppableArea>
        )}
        
      </ImageContainer>
      <div className="p-col-12 p-md-3 p-xl-4">
        <UploadedFilesTitle>Uploading File</UploadedFilesTitle>
        {/* <Divider layout="horizontal" /> */}
        <UploadedFilesContainer>
          <div id='getImages'>
          {files[0] &&
            files.map((image, i) => {
              return (
                <UploadedFilesImage
                  src={image}
                  alt="element"
                  key={i}
                  onClick={() => {
                    setimageURL(files[i]);
                    setindicator(i); //deleting index
                  }}
                />
              );
            })}
          </div>
        </UploadedFilesContainer>
      </div>
    </AnnounceComponent>
  );
};

export default Image;
